import { Popover } from "antd"
import { IDictSelectorUI } from "./types"

import { Button, Empty, Flex, Input, Loader, Table } from "@ui/index"

import imgEmpty from '@img/empty.svg'
import { IconClearClose, IconSearch } from "@img/icons"
import CommonService from "@services/common.service"


/** Выбор данных из справочника */
export const DictSelectorUI = ({ 
    isOpen, dictName, isLoading, selectedID, isSearch, isScroll, txtSearch, commonList, children, setIsOpen, handleButtonOk 
}: IDictSelectorUI) => {

    /** Тело всплывающего контейнера */
    const popoverContent = (
        <Flex gap="8px" maxHeight="250px" className="fontStyle">
            {isLoading && <Loader isOpen={isLoading} backdrop color='var(--color_txt_accent)' />}

            <Input size='md' paddingRight='2px' {...txtSearch}
                isRendered={isSearch}
                placeholder='Поиск по ключевым словам'
                prefix={<IconSearch width='18px' height='18px' color="var(--foreground_accent_default)" />}
                suffix={txtSearch.value && 
                    <Button id='toolTipClear' size='sm' variant='iconInput' onClick={() => txtSearch.setValue('')}>
                        <IconClearClose width='18px' height='18px' />
                    </Button>
                }
            />

            <Table.Content gap="4px" isScrollVertical={isScroll}>
                {commonList.value.length === 0
                    ? <Empty image={imgEmpty} />
                    : commonList.value.filter((val) => {
                        const { name } = val
                        const searchValue = txtSearch.value ? txtSearch.value.toString().toLowerCase() : ''

                        return (name.toString().toLowerCase().includes(searchValue)) ? val : false
                    }).map((item, index) => (
                        <Table.RowCheckBox key={index + 1} 
                            header={index + 1} headerWidth="40px"
                            onClick={() => { 
                                selectedID.setValue(item.id)
                                handleButtonOk(item.id) 
                            }}
                        >
                            <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                <p>{item.name}</p>
                                {dictName === 'contractProgramInfo' && <b>{CommonService.formatHours(Number(item.param3))} 👉 {item.param4} ₽</b>}
                            </div>
                        </Table.RowCheckBox>
                    ))
                }
            </Table.Content>
        </Flex>
    )


    return (
        <Popover
            arrow={{ pointAtCenter: true }}
            content={popoverContent}
            open={isOpen}
            onOpenChange={setIsOpen}
            trigger="click"
            placement="bottomRight"
            styles={{ root: { zIndex: '10000', maxWidth: '350px', minWidth: '300px' } }}
        >
            <div style={{ cursor: 'pointer' }}>
                {children}
            </div>
        </Popover>
    )
}